<template>
  <div class="title">
    <KaaliTitle
      v-if="type === 'kaali'"
      :title="title"
      :description="description"
      :displayHR="displayHR"
    />
  </div>
</template>

<script>
import KaaliTitle from '@/components/general-ui/titles/Kaali.vue';

export default {
  name: 'Title',
  components: {
    KaaliTitle,
  },
  props: {
    title: String,
    description: {
      type: String,
      default: ''
    },
    displayHR: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      type: ws_vue_store.config.title,
    };
  },
  computed: {

  },
  methods: {

  },
};
</script>
